import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import InstructionRepeatOverlay from '../FormativeMultipleChoice/InstructionRepeatOverlay';

export default function BucketingMediaSection({
  hasVideo,
  hasImage,
  hideMedia,
  videoURL,
  imageURL,
  speech,
  videoPlaying,
  maxVideoReplays,
  onVideoReplay,
  unmountVideoWhenDone,
  suppressVideoReplayOverlay,
  showRepeatOverlay,
  showRepeatOverlayReplay,
  pointerTarget,
  onRepeatOverlayReplay,
  onRepeatOverlayNext,
  onVideoStart,
  onVideoDone,
}) {
  const showsVideo = hasVideo && !hideMedia;
  const showsImage = hasImage && !hasVideo && !hideMedia;

  if (!showsVideo && !showsImage) {
    if (!showRepeatOverlay) return null;
    return (
      <div className="bucketing__media">
        <div className="bucketing__mediaSlot bucketing__audioOnlySlot">
          <InstructionRepeatOverlay
            pointerTarget={pointerTarget}
            showReplay={showRepeatOverlayReplay}
            onReplay={onRepeatOverlayReplay}
            onNext={onRepeatOverlayNext}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="bucketing__media">
      {showsVideo && (
        <div className="bucketing__mediaSlot">
          <VideoPlayer
            videoURL={videoURL}
            text="Bucketing Video"
            unmountWhenDone={unmountVideoWhenDone}
            key="bucketingVideo"
            speech={speech}
            videoPlaying={videoPlaying}
            maxReplays={maxVideoReplays}
            onReplayClick={onVideoReplay}
            suppressReplayOverlay={suppressVideoReplayOverlay}
            onStart={onVideoStart}
            onDone={onVideoDone}
            useButtonLabels={false}
            useClearButtons
          />
          {showRepeatOverlay && (
            <InstructionRepeatOverlay
              pointerTarget={pointerTarget}
              showReplay={showRepeatOverlayReplay}
              onReplay={onRepeatOverlayReplay}
              onNext={onRepeatOverlayNext}
            />
          )}
        </div>
      )}
      {showsImage && (
        <div className="bucketing__staticImage">
          <div className="bucketing__staticImageCell">
            <img src={imageURL} alt="Bucketing prompt" />
            {showRepeatOverlay && (
              <InstructionRepeatOverlay
                pointerTarget={pointerTarget}
                showReplay={showRepeatOverlayReplay}
                onReplay={onRepeatOverlayReplay}
                onNext={onRepeatOverlayNext}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
